// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"eb5b2caa","838":"58c56cbf","863":"92bd7dd9"}[chunkId] + ".chunk.js";
};